import { Fragment, useMemo } from "react";
import { ResponsiveNirfTable } from "../common/ResponsiveNirfTable";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import { checkApi } from "../../Authentication/AxiosInstance";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const NIRFRankings = () => {
  
  const fetchNIRF = async () => {
    const res = await checkApi.get(`${API_ENDPOINT}/capzone/rankings/`);
    return res.data;
  };

  const { data, status } = useQuery({
    queryKey: ["RankData"],
    queryFn: fetchNIRF,
  });

  const columns = useMemo(
    () => [
      // {
      //   accessorKey: "i001_inst_ranktype",
      //   header: "Type",
      //   maxSize: "250",
      // },
      {
        accessorKey: "i001_inst_year",
        header: "Academic Year",
        maxSize: "100",
      },
      // {
      //   accessorKey: "i001_inst_code",
      //   header: "Institute ID",
      //   maxSize: "100",
      // },
      {
        accessorKey: "i001_inst_name",
        header: "Institute Name",
        minSize: "300",
      },
      {
        accessorKey: "i001_inst_city",
        header: "City",
        maxSize: "100",
      },
      {
        accessorKey: "i001_inst_state",
        header: "State",
        maxSize: "100",
      },

      {
        accessorKey: "i001_inst_rank",
        header: "Rank",
        maxSize: "50",
      },

      {
        accessorKey: "i001_inst_score",
        header: "Score",
        maxSize: "50",
      },
    ],
    []
  );

  //console.log(data);

  return <Fragment>{status === "pending" ? <LoadingPage /> : status === "error" ? <ErrorPage /> : <ResponsiveNirfTable data={data} columns={columns} />}</Fragment>;
};
